module.exports = __webpack_public_path__ + "static/img/logo_dark.359b2f23.svg";